<div class="container">
  <fgb-barcode></fgb-barcode>
</div>

<div class="d-block d-lg-none">
  <ul class="nav payment-nav">
    <a class="nav-item" [routerLink]="['/payment']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'navbar.payment' | translate }}</label>
      <div class="border-for-label nav-border-short"></div>
    </a>
    <a
      class="nav-item"
      [routerLink]="['/payment-history']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'navbar.ecash.history' | translate }}</label>
      <div class="border-for-label nav-border-short"></div>
    </a>
  </ul>
</div>

<div class="container">
  <fgbcl-card-token-list
    [regex]="regex"
    [provider]="provider"
    [redirectUrl]="'/payment/result'"
    [failureUrl]="'/payment/failure'"
    [cardIssuerProvider]="'payment.provider.name' | translate"
    [showExpiry]="true"
  ></fgbcl-card-token-list>

  <fgbcl-ecash-description></fgbcl-ecash-description>
</div>

<div class="container d-none d-lg-block mt-4">
  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
  ></fgb-transaction-history>
</div>
